<div class="container_width">
  <div class="grid w-full ">
    <div class="col-12 lg:col-7">
      <app-calendar-view [userId]="userId" [mentorId]="mentorId" [isMentorView]="true"></app-calendar-view>
    </div>
    <div class="col-12 lg:col-5 pt-4 lg:pt-0 lg:pl-4">
      <app-additional-information-right-section [infoType]="infotype.General" (taskUpdated)="refreshCalendar()"></app-additional-information-right-section>
    </div>
  </div>
</div>
